import styled from "styled-components";
import ColorHelper from "../../../../helpers/ColorHelper";

export const StyledEmployeeRegistrationDescription = styled.h2`
  text-align: center;
`;

export const StyledEmployeeRegistrationText = styled.p`
  text-align: center;
`;

export const StyledEmployeeRegistrationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  /* Make every row as tall as the tallest row, so all buttons have the same height */
  grid-auto-rows: 1fr;
  gap: ${(props) => props.theme.spacing.large};
  width: 100%;
`;

export const StyledEmployeeRegistrationButtonContent = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: ${(props) => props.theme.spacing.normal};
  height: 100%;
`;

export const StyledEmployeeRegistrationName = styled.span`
  /* Wrap very long names (even single long words) instead of overflowing the button */
  overflow-wrap: anywhere;
`;

/**
 * The presence status pill. It has its own background color, so it stays readable on every button color of the theme.
 * The text color is black or white, whichever is the most readable on the state color.
 */
export const StyledEmployeeRegistrationPresence = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.85em;
  background-color: ${(props) =>
    props.$present
      ? props.theme["settings.state.color.success"]
      : props.theme["settings.state.color.error"]};
  color: ${(props) =>
    ColorHelper.getReadableTextColor(
      props.$present
        ? props.theme["settings.state.color.success"]
        : props.theme["settings.state.color.error"],
    )};
`;
